"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveIcon = exports.RemoveButton = exports.CalendarIcon = exports.InputWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const material_1 = require("@mui/material");
const CalendadIcon_1 = require("../../../assets/icons/CalendadIcon");
const CloseGrayIcon_1 = require("../../../assets/icons/CloseGrayIcon");
exports.InputWrapper = styled_components_1.default.div(() => (0, styled_components_1.css) `
    position: relative;

    & div > .MuiFormLabel-root {
      font-size: 12px;
    }
  `);
exports.CalendarIcon = (0, styled_components_1.default)(CalendadIcon_1.CalendarIcon)(({ $isClickable }) => (0, styled_components_1.css) `
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translate(0, -50%);
    cursor: ${$isClickable ? 'pointer' : 'not-allowed'};
    opacity: ${$isClickable ? 1 : 0.5};
  `);
exports.RemoveButton = (0, styled_components_1.default)(material_1.IconButton) `
  padding: 4px;
  margin-right: -4px;
`;
exports.RemoveIcon = (0, styled_components_1.default)(CloseGrayIcon_1.CloseGrayIcon) `
  width: 21px;
  height: 21px;
`;
